<template>
  <van-nav-bar
    title="教育综合服务管理平台"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
    fixed
    placeholder
  ></van-nav-bar>

  <van-cell-group inset style="margin-top: 20px">
    <van-cell title="关于" size="large" label="教育综合服务管理平台 v1.0.1" />
  </van-cell-group>

  <!-- 服务电话：一行三格，纯展示（不可拨打，所以不绑点击事件、不设手型光标） -->
  <div class="service-block">
    <p class="service-title">服务电话</p>
    <div class="phone-row">
      <div
        v-for="phone in servicePhones"
        :key="phone"
        class="phone-item"
      >
        {{ phone }}
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { Cell, CellGroup } from "vant";
import { SERVICE_PHONES } from "../config";

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  setup() {
    const router = useRouter(); //传值
    const toAbout = () => {
      router.replace("/");
    };

    const toResetPwd = () => {
      router.push({
        path: "/resetpwd",
      });
    };
    const onClickLeft = () => {
      router.go(-1);
    };

    // 服务电话唯一来源：src/config.js（登录页也用同一份，换号只改那里）
    const servicePhones = SERVICE_PHONES;

    onMounted(() => {
      /* eslint-disable */
      // payType.value = Route.query.payType;
      // onLoad();
    });

    return {
      toResetPwd,
      toAbout,
      onClickLeft,
      servicePhones,
    };
  },
};
</script>

<style lang="less" scoped>
/* 服务电话：无背景无边框，号码格用白块在页面灰底（#f2f2f2）上区分 */
.service-block {
  margin: 24px 16px 0;
}

.service-title {
  margin: 0 0 8px;
  font-size: 13px;
  color: #999;
}

.phone-row {
  display: flex;
  margin: 0 -4px;
}

.phone-item {
  flex: 1;
  min-width: 0;
  margin: 0 4px;
  padding: 10px 0;
  text-align: center;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  border-radius: 4px;
}
</style>
